import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { ChangingDirectionType, ChangingParameters, Restrictions } from "../types";
import { optionParametersSelectorManager } from "../utils/OptionParametersSelectorManager";
import { ToolsPanelButton } from "./ToolsPanelButton";
import { SelectorButtonContent } from "../views";

export function OptionExpirationSelector({
    parameters
}: {
    parameters: ChangingParameters;
}) {
    const [restrictions, setRestrictions] = useState<Restrictions | null>(
        optionParametersSelectorManager.getExpirationRestrictions(parameters));
    
    const handleChange = async (direction: ChangingDirectionType): Promise<void> => {
        await optionParametersSelectorManager.changeExpiration(direction, parameters);
        setRestrictions(optionParametersSelectorManager.getExpirationRestrictions(parameters));
    }

    useEffect(() => {
        setRestrictions(optionParametersSelectorManager.getExpirationRestrictions(parameters));
    }, [parameters.selectedOrder]);
    
    const isButtonDisabled = (isRestricted: boolean | undefined) =>
        !optionParametersSelectorManager.isCommandApplicable(parameters) ||
        !(isRestricted ?? false);
    
    return (
        <Stack direction="row" spacing={0.5}>
            <ToolsPanelButton
                tooltipText="Change to the previous expiration"
                disabled={isButtonDisabled(restrictions?.canChangeToPrevious)}
                onChanged={() => handleChange(ChangingDirectionType.Previous)}
            >
                <SelectorButtonContent content='E' direction={ChangingDirectionType.Previous} />
            </ToolsPanelButton>
            <ToolsPanelButton
                tooltipText="Change to the next expiration"
                disabled={isButtonDisabled(restrictions?.canChangeToNext)}
                onChanged={() => handleChange(ChangingDirectionType.Next)}
            >
                <SelectorButtonContent content='E' direction={ChangingDirectionType.Next} />
            </ToolsPanelButton>
        </Stack>
    );
}